import type { GroupShowQueryType } from '@frontend/graphql/queries/groups'

import { ContactStats, SupportersStats } from '../features/supporters/GroupShowStats'
import GroupCard from '../features/supporters/GroupShowGroupCard'
import { GroupPageHeader } from '../features/group-page/GroupPageHeader'
import { DialogProvider, type DialogRegistry } from '@components/DialogProvider'
import { EditGroupPublicDescriptionDialog } from '../features/edit-group-public-description/EditGroupPublicDescriptionDialog'
import { SupporterExportDialog } from '../features/export-supporters/SupporterExportDialog'
import { PageLayout } from '@components/layouts/PageLayout'
import type { SharedInertiaProps, RouteProps } from '../types/groupTypes'

const groupOverviewRegistry: DialogRegistry = {
  editGroupPublicDescription: EditGroupPublicDescriptionDialog,
  supporterExport: SupporterExportDialog,
}

type GroupOverviewType = {
  globalMailerSender: string
  group: GroupShowQueryType['group']
  newSupportersCount: number
}

function GroupOverview({
  globalMailerSender,
  group,
  newSupportersCount,
  permissions,
  routes,
}: GroupOverviewType & SharedInertiaProps & RouteProps) {
  const { totalCount } = group.supporters

  return (
    <DialogProvider registry={groupOverviewRegistry}>
      <PageLayout.Root>
        <GroupPageHeader group={group} current="overview" permissions={permissions} routes={routes} />
        <PageLayout.Body>
          <div className="tw:flex tw:flex-col tw:gap-6">
            <GroupCard
              globalMailerSender={globalMailerSender}
              group={group}
              permissions={permissions}
              routes={routes}
              totalCount={totalCount}
            />
            <div className="tw:flex tw:gap-4">
              <SupportersStats total={totalCount} last30Days={newSupportersCount} />
              <ContactStats
                emails={group.emailContacts.totalCount}
                sms={group.smsContacts.totalCount}
                calls={group.phoneContacts.totalCount}
              />
            </div>
          </div>
        </PageLayout.Body>
      </PageLayout.Root>
    </DialogProvider>
  )
}

export default GroupOverview
